import type { FunctionComponent } from 'react';
import { getImagesStaticUrl } from '../../../helpers';
import useScreenMode from '../../../hooks/useScreenMode';
import { MOBILE } from '../../constants';
import * as styles from './banner.module.scss';

type BannerProps = {
  title: string;
  subtitle: string;
};

const Banner: FunctionComponent<BannerProps> = ({ title = '', subtitle = '' }) => {
  const screenMode = useScreenMode();
  return (
    <div
      className={styles.banner}
      style={
        screenMode === MOBILE
          ? {}
          : { backgroundImage: `url(${getImagesStaticUrl('subscribe-hero-desktop.png')})` }
      }
      data-testid="banner-container"
    >
      <h1 className={styles.banner__title}>{title}</h1>
      <p className={styles.banner__subtitle} data-testid="banner-subtitle">
        {subtitle}
      </p>
      {screenMode !== MOBILE && (
        <img src={getImagesStaticUrl('subscribe-white-wave.svg')} alt="white wave" />
      )}
    </div>
  );
};

export default Banner;
